import { render, staticRenderFns } from "./ItemChipCustomerItemNumber.vue?vue&type=template&id=0b43ea52&scoped=true"
import script from "./ItemChipCustomerItemNumber.vue?vue&type=script&lang=ts"
export * from "./ItemChipCustomerItemNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b43ea52",
  null
  
)

export default component.exports